module.exports = __webpack_public_path__ + "static/empty-states-value-props-body-dont-fafffb65a93255774f2c15c40d30e953.png";